<template>
    <div class="acomodar"> 
            <Cliente class="achicar"/>
    </div>
</template>

<script>
import Cliente from '../../components/Cliente/cliente.vue'
export default {
    name: 'BYCliente',
    components:{
        Cliente
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>
.acomodar {
  box-shadow: rgba(116, 59, 59, 0.2) 0px 2px 16px 0px;
  margin-top: 9px;
  margin-bottom: 0px;
  padding-bottom: 00%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.25%;
  margin-right: 10px;
  height: 100vh;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y : hidden;
  padding-top: 0%;
  
}


</style>